/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { Pipe, PipeTransform } from '@angular/core';
import { GedFile } from '../model/ged-file';

@Pipe({
  name: 'file',
  standalone: true,
})
export class FilePipe implements PipeTransform {
  transform(value: GedFile, url: string): any {
    if (value.getFile()) {
      return value.encoded;
    } else {
      if (url) {
        return `${url}/${value.encoded}`;
      } else {
        return `${value.encoded}`;
      }
    }
  }
}
